import { isSameDay } from 'date-fns';

import { TableHeader } from '@modules/tours/table-toolkit/classes/table-header';

export class DateHeader extends TableHeader<Date> {
  protected isEqual(s1: Date, s2: Date): boolean {
    return isSameDay(s1, s2);
  }
}
